import { FormGroup, Validators } from '@angular/forms';

import { AccountValidationAction } from './account-validation-action.enum';
import { FieldValidatorsMap, FormValidatorsMap } from '../interfaces';

import { ObjectLike } from 'app/interfaces';
import { FormModel } from 'app/models';
import { isIban, requiredWith } from 'app/validators';

export class AccountRules extends FormModel<AccountValidationAction> {
    baseValidators: FieldValidatorsMap = {
        amount: [Validators.required, Validators.min(0.01)],
        email: [],
        emailRequired: [],
        receiverIban: [],
        receiverName: [],
        referenceNr: [],
        description: [],
    };

    formValidators: FormValidatorsMap = {
        [AccountValidationAction.AddMoney]: {
            email: [requiredWith(['emailRequired'])],
        },
        [AccountValidationAction.WithdrawMoney]: {
            receiverIban: [Validators.required, isIban()],
            receiverName: [Validators.required],
        },
    };

    getAddMoneyForm(formFrom: ObjectLike = {}): FormGroup {
        return this.createFormGroup(AccountValidationAction.AddMoney, formFrom);
    }

    getUsergroupWithdrawalForm(formFrom: ObjectLike = {}): FormGroup {
        return this.createFormGroup(AccountValidationAction.WithdrawMoney, formFrom);
    }
}
